import initStore from './initStore';


let store;

const storeBuild = () => {
  if (!store) store = initStore();
  return store;
};

export default storeBuild();
